'use client';
import { CatHeading } from 'components/blocks-components';

export const Categories = ({ name, seoURL }) => {
  return (
    <li>
      <a href={seoURL}>
        <CatHeading variant={'label-lg'} aria-label={name} aria-level={2}>
          {name}
        </CatHeading>
      </a>
    </li>
  );
};
